import { axios } from '@/utils/request'
import { filterData } from '@/utils/util'
const api = {
  detail: '/egcms/detail',
  action: '/egcms/action',
  allDetail: '/egcms/materialDetail',
  materialList: '/egcms/materialList'
}
// 查询素材详情
export function getEgcms(parameter) {
  return axios({
    url: api.detail,
    method: 'get',
    params: parameter || {},
    func:'查询素材详情'
  })
}
// 审核完成
export function saveEgcms(parameter) {
  return axios({
    url: api.action,
    method: 'post',
    data: parameter || {},
    headers: {
      'Content-Type':'application/json;utf-8'
    },
    func:'审核完成'
  })
}
// 查询素材详情
export function getAllDetail(parameter) {
  return axios({
    url: api.allDetail,
    method: 'get',
    params: parameter || {},
    func:'查询素材详情'
  })
}
// 查询素材料表
export function getMaterialList(params) {
  return axios({
    url: api.materialList,
    method: 'get',
    params: filterData(params),
    func:'查询素材料表'
  })
}
